import './App.css';
import { Route, Routes } from "react-router-dom";
import Home from './pages/Home';
import ContactPage from './pages/Contact';
import AboutPage from './pages/About';
import Avgas from './pages/cultivars/Av-gas';
import Blackberrymoonrocks from './pages/cultivars/Blackberrymoonrocks';
import Bubba from './pages/cultivars/Bubba';
import Cadillacrainbows from './pages/cultivars/Cadillacrainbows';
import Chemicalbromance from './pages/cultivars/Chemicalbromance';
import Donkeybutter from './pages/cultivars/Donkeybutter';
import Dr from './pages/cultivars/Dr';
import FastOrange from './pages/cultivars/FastOrange';
import FruityPebbles2 from './pages/cultivars/FruityPebbles2';
import GastroPop from './pages/cultivars/GastroPop';
import Georgia from './pages/cultivars/Georgia';
import IslandPink from './pages/cultivars/IslandPink';
import Jealousy from './pages/cultivars/Jealousy';
import JellyBreath from './pages/cultivars/JellyBreath';
import MacDonut from './pages/cultivars/MacDonut';
import MasterKushUltra from './pages/cultivars/MasterKushUltra';
import Cultivars from './pages/Cultivars';
import PeanutButterRockstar from './pages/cultivars/PeanutButterRockstar';
import Permanentmarker from './pages/cultivars/Permanentmarker';
import Pinetar from './pages/cultivars/Pinetar';
import PlatinumLemonCherryGelato from './pages/cultivars/PlatinumLemonCherryGelato';
import RottenRuntz from './pages/cultivars/RottenRuntz';
import Rockstar from './pages/cultivars/Rockstar';
import WhiteRuntz from './pages/cultivars/WhiteRuntz';
import SleepyJoeOG from './pages/cultivars/SleepyJoeOG';
import TomFordPink from './pages/cultivars/TomFordPink';
import TropicalCherryBlast from './pages/cultivars/TropicalCherryBlast';
import Zoap from './pages/cultivars/Zoap';
import ThankYouPage from './pages/ThankYouPage';


function App() {
  return (
   <>
    <Routes>
    <Route path="/" element={<Home/>} />
    <Route path="/contact" element={<ContactPage/>} />
    <Route path="/about" element={<AboutPage/>} />
    <Route path="/thankyou" element={<ThankYouPage/>} />


    {/*Cultivars products*/}
    <Route path="/cultivars" element={<Cultivars/>} />
    <Route path="/cultivars/av-gas" element={<Avgas/>} />
    <Route path="/cultivars/blackberry-moonrocks" element={<Blackberrymoonrocks/>} />
    <Route path="/cultivars/bubba" element={<Bubba/>} />
    <Route path="/cultivars/cadillac-rainbows" element={<Cadillacrainbows/>} />
    <Route path="/cultivars/chemical-bromance" element={<Chemicalbromance/>} />
    <Route path="/cultivars/donkey-butter" element={<Donkeybutter/>} />
    <Route path="/cultivars/dr" element={<Dr />} />
    <Route path="/cultivars/fast-orange" element={<FastOrange />} />
    <Route path="/cultivars/fruity-pebbles-2-0" element={<FruityPebbles2 />} />
    <Route path="/cultivars/gastro-pop" element={<GastroPop />} />
    <Route path="/cultivars/georgia" element={<Georgia />} />
    <Route path="/cultivars/island-pink" element={<IslandPink />} />
    <Route path="/cultivars/jealousy" element={<Jealousy/>} />
    <Route path="/cultivars/jelly-breath" element={<JellyBreath />} />
    <Route path="/cultivars/mac-donut" element={<MacDonut />} />
    <Route path="/cultivars/master-kush-ultra" element={<MasterKushUltra  />} />
    <Route path="/cultivars/peanut-butter-rockstar" element={<PeanutButterRockstar />} />
    <Route path="/cultivars/permanent-marker" element={<Permanentmarker />} />
    <Route path="/cultivars/pine-tar" element={<Pinetar />} />
    <Route path="/cultivars/platinum-lemon-cherry-gelato" element={<PlatinumLemonCherryGelato />} />
    <Route path="/cultivars/rotten-runtz" element={<RottenRuntz />} />
    <Route path="/cultivars/rockstar" element={<Rockstar />} />
    <Route path="/cultivars/white-runtz" element={<WhiteRuntz />} />
    <Route path="/cultivars/sleepy-joe-og" element={<SleepyJoeOG />} />
    <Route path="/cultivars/tom-ford-pink" element={<TomFordPink />} />
    <Route path="/cultivars/tropical-cherry-blast" element={<TropicalCherryBlast />} />
    <Route path="/cultivars/zoap" element={<Zoap />} />

    </Routes>
   </>
  );
}

export default App;
